import moment from 'moment';

class User {
  constructor({
    _id = null,
    role = '',
    email = '',
    firstName = '',
    lastName = '',
    activated = null,
    createdAt = null,
    updatedAt = null,
    avatar,
    wodsAttended = [],
  }) {
    const { id: imageId = null, url: imageUrl = '' } = avatar ? avatar : {};
    this.id = _id;
    this.role = role;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.activated = activated ? moment(activated) : null;
    this.createdAt = createdAt ? moment(createdAt) : null;
    this.updatedAt = updatedAt ? moment(updatedAt) : null;
    this.avatar = {
      id: imageId,
      url: imageUrl,
    };
    this.wodsAttended = wodsAttended;
  }

  static getFullName(user) {
    return `${user.firstName} ${user.lastName}`;
  }
}

export default User;
